'use strict';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** Niche
//***********************************************************************************
//***********************************************************************************

import { cn_element } from './cn_element';
import { cn_box, cn_point_on_segment, cnx_clone } from '../utils/cn_utilities';
import { cn_element_visitor } from '../utils/visitors/cn_element_visitor';
import { cn_scene } from './cn_scene';
import { cn_camera } from '../svg/cn_camera';

export class cn_user_measure extends cn_element {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_element} parent
     */
    constructor(parent) {
        super(parent);
        this.class_name = 'cn_user_measure';


        //*** Model data
        this.positions = [[0,0,0],[0,0,0]];
        this.normals = [[],[]];
    }

    //***********************************************************************************
    //**** serialize
    //***********************************************************************************
    serialize() {
        var json = this.serialize_element();
        json.locked = this.locked;
        json.positions = this.positions;
        json.normals = this.normals;
        return json;
    }

    static unserialize(json, parent) {
        if (typeof (json.ID) != 'string') return false;

        var user_measure = new cn_user_measure(parent);
        user_measure.unserialize_element(json);
        
        if (typeof (user_measure.positions) == 'object')
            user_measure.positions = json.positions;

        if (typeof (user_measure.normals) == 'object')
            user_measure.normals = json.normals;

        if (typeof (user_measure.locked) == 'boolean')
            user_measure.locked = json.locked;

        return user_measure;
    }

    /**
     *
     * @returns {cn_user_measure}
     */
    clone() {
        let c = new cn_user_measure(this.parent);
        c.positions = this.normals.map(n => cnx_clone(n));
        c.normals = this.normals.map(nn => nn.map(n => cnx_clone(n)));
        return c;
    }

    
    //***********************************************************************************
    //**** Draw
    //***********************************************************************************
    draw(camera, add_classes = []) {
        let html = "";
        html += camera.draw_measure(this.positions[0], this.positions[1],null,false,0,add_classes);
        if (add_classes.includes("selected") && !this.locked)
        {
            for (var niter=0;niter<2;niter++) {
                let prj = camera.world_to_screen(this.positions[niter]);
                if (prj.length)
                    html += `<circle cx="${prj[0]}" cy="${prj[1]}" r="5" fill="blue" />`;
            }
        }
        return html;
    }

    //***********************************************************************************
    //**** Contains
    //***********************************************************************************
    contains(point, tolerance = 0) {
        return cn_point_on_segment(point,this.positions[0],this.positions[1],tolerance);
    }

    //***********************************************************************************
    /**
     * Returns bounding box
     * @returns {cn_box}
     */
    get_bounding_box() {
        var box = new cn_box();
        this.positions.forEach(v => box.enlarge_point(v));
        return box;
    }

    /**
     * Returns bounding box
     * @param {cn_camera} camera
     * @returns {cn_box}
     */
    get_screen_bounding_box(camera) {
        var box = new cn_box();
        this.positions.forEach(v => box.enlarge_point(camera.world_to_screen(v)));
        return box;
    }

    /**
     * Accept element visitor
     *
     * @param {cn_element_visitor} element_visitor
     */
    accept_visitor(element_visitor) {
        element_visitor.visit_niche(this);
    }

    contains_3d(mouse_event) {
        let p0 = mouse_event.camera.world_to_screen(this.positions[0]);
        if (!p0.length) return false;
        let p1 = mouse_event.camera.world_to_screen(this.positions[1]);
        if (!p1.length) return false;
        return cn_point_on_segment(mouse_event.mouse_screen,p0,p1,10);
    }
}

